import React, { useState, useRef } from 'react';
import moment from 'moment';
import XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';
import { Input } from 'reactstrap';
import { toast } from 'react-toastify';

import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import { Button } from 'components/Button/RoundButton';
import { DropdownContainer, DropdownMenuContainer, Divider } from '../../ReportPage/components/styles';
import { ITag } from '../styles';
import { DateContainer, DateLabel, DropdownItem } from './styles';

let currentDate = moment();
let initialDate = currentDate.subtract(1, 'months');
initialDate = initialDate.format('YYYY-MM-DD');

export default function ExportXLSDropdown({ tickets }) {
  const dropdownRef = useRef(null);
  const [isOpenDropdown, setIsOpenDropdown] = useDetectOutsideClick(dropdownRef, false);

  const [startDate, setStartDate] = useState(initialDate);
  const [endDate, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD'));

  const exportToExcel = () => {
    if ((startDate && !endDate) || (endDate && !startDate)) return toast.error('Please select both the dates');
    if (endDate < startDate) return toast.error('End date must be greater than start date');

    let excelData = [];
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8';
    const fileExtension = '.xlsx';

    tickets.forEach((ticket) => {
      let ticketDate = ticket.completedAt || ticket.startedAt || ticket.createdAt;
      if (startDate && endDate && !(ticketDate >= startDate && ticketDate <= endDate)) return;

      let result;
      if (typeof ticket.distributionPercentage === 'number') {
        result = ticket.distributionPercentage;
      } else if (ticket.completedAt) {
        result = ticket.result;
      } else {
        result = 'N/A';
      }

      let scale;
      if (ticket.distributionPercentage) {
        scale = 100;
      } else {
        scale = ticket.totalQuestions ? ticket.totalQuestions : ticket.scale;
      }

      excelData.push({
        Name: ticket.candidateName,
        Email: ticket.candidateEmail,
        Test: ticket.testName,
        Owner: ticket.customerName,
        Date: moment(ticket.completedAt || ticket.startedAt || ticket.createdAt).format('YYYY-MM-DD hh:mm'),
        Status: ticket.completedAt ? 'Finished' : ticket.startedAt ? 'Started' : 'Not started',
        Score: result,
        MaxScore: scale,
      });
    });

    let date = new Date();
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    let filename = `Test_Report-${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}.xls`;

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename + fileExtension);
  };

  return (
    <DropdownContainer>
      <Button small primaryBlue primaryGreenBorder onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
        <ITag className="fa-regular fa-file-excel" />
        Export as XLS &nbsp;<i className="fa fa-caret-down" aria-hidden="true"></i>
      </Button>
      {isOpenDropdown && (
        <DropdownMenuContainer ref={dropdownRef}>
          <DateContainer>
            <DateLabel>Start Date:</DateLabel>
            <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </DateContainer>
          <DateContainer>
            <DateLabel>End Date:</DateLabel>
            <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </DateContainer>
          <Divider />
          <DropdownItem onClick={() => exportToExcel()}>Export</DropdownItem>
        </DropdownMenuContainer>
      )}
    </DropdownContainer>
  );
}
